import { cn } from "@/lib/utils";

export function NoxusKeyBind({
  commandWindows,
  commandMac,
  isDark,
}: {
  commandWindows: string;
  commandMac: string;
  isDark?: boolean;
}) {
  const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

  const command = isMac ? commandMac : commandWindows;

  return (
    <div
      className={cn(
        "rounded-sm px-1",
        isDark ? "border border-gray-0" : "bg-gray-50"
      )}
    >
      <span
        className={cn(
          "text-xs leading-4",
          isDark ? "text-gray-0" : "text-gray-400"
        )}
      >
        {command}
      </span>
    </div>
  );
}
